import React from 'react';

const Services = () => {
  return (
    <div className="page about-page">
      <p/>
      <div className="card mt-6">
        <h2 className="card-title">Our Services</h2>
        <p>
          Our services encompass end-to-end Reporting, advanced Analytics, and seamless
           Data Acquisition & Migration to help organizations make informed, data-driven 
           decisions. We also specialize in Web and Application Development, creating reliable
            digital solutions tailored to modern business needs. Through our industry-focused 
            Training programs, we empower individuals with practical skills, while our flexible
             Staffing services ensure clients receive the right talent at the right time. 
             Together, we deliver integrated solutions that drive efficiency, innovation, 
             and growth.
        </p>
      </div>

      <div className="features-grid mt-6">
        <div className="feature-card">
          <div className="feature-icon">📶</div>
          <h3>Reporting</h3>
          <p>We deliver accurate, timely, and customized reports that help organizations
             make data-driven decisions with confidence.</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">⚡</div>
          <h3>Analytics</h3>
          <p>Our analytics solutions transform raw data into insights, 
            enabling smarter strategies, improved performance, and measurable outcomes.</p>
        </div>
        
        <div className="feature-card">
          <div className="feature-icon">🧊</div>
          <h3>Data Acquisition & Migration</h3>
          <p>We ensure secure, seamless, and efficient data acquisition and 
            migration from legacy systems to modern platforms.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">💻</div>
          <h3>Web & Application Development</h3>
          <p>We develop scalable, user-friendly web and mobile applications tailored to meet evolving business needs.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">📕</div>
          <h3>Training</h3>
          <p>We provide practical, industry-focused training programs that enhance skills and ensure workforce readiness.</p>
        </div>

        <div className="feature-card">
          <div className="feature-icon">👪</div>
          <h3>Staffing</h3>
          <p>We supply skilled and vetted professionals through flexible staffing models to meet diverse project and organizational needs.</p>
        </div>
      </div>
    </div>
  );
};

export default Services;